// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CKBA","content":"styles_content__1xUpq"};